module.exports = __webpack_public_path__ + "img/entry1.2f4e2606.png";